module.exports = __webpack_public_path__ + "static/media/arrow_downward_off.f8a806d1.svg";